import React, { useState, useEffect } from 'react';
import { api } from '../../api/client';

export const S3ImageDisplay: React.FC<{
  s3Url: string;
  uniqueId: string;
  canvasRef: (el: HTMLCanvasElement | null) => void;
  imageRef: (el: HTMLImageElement | null) => void;
  onImageLoad: () => void;
}> = ({ s3Url, canvasRef, imageRef, onImageLoad }) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);
    setImageSrc(null);

    api.dvcviewer
      .getPresignedUrl(s3Url)
      .then((res) => {
        if (!cancelled) {
          setImageSrc(res.data.presigned_url);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError(true);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [s3Url]);

  if (loading) {
    return (
      <div className="dvc-image-loading">
        <div>⏳</div>
        <p>Loading S3 image...</p>
      </div>
    );
  }

  if (error || !imageSrc) {
    return (
      <div className="dvc-image-loading">
        <div>❌</div>
        <p>Failed to load S3 image</p>
      </div>
    );
  }

  return (
    <div className="dvc-s3-image-container">
      <img
        ref={imageRef}
        src={imageSrc}
        alt="Preview"
        className="dvc-s3-image"
        onLoad={onImageLoad}
      />
      <canvas ref={canvasRef} className="dvc-bbox-canvas" />
    </div>
  );
};
